import React, { useEffect, useState } from 'react';
import { MainContainer } from './../Recognition/RecognitionActivity/styles';
import PropTypes from "prop-types";
import { PerformanceMain, YearlyCard } from './styles';
import { ImageUrl } from '../../utils/constants';
import { fetchApi, getInitials } from '../../utils/methods';
import { toast } from 'react-toastify';
import { GetPerformance } from '../../redux/constants/apiConstants';
import CommonTable from '../common/CommonTable/CommonTable';
import { NameInitials } from '../Manager/styles';
 

const Performance = ({ selectedFilter, companyInfo }) => {
  const [data, setData] = useState([]);
  const [showAll, setShowAll] = useState(false);
   

  

  const handleShowMore = (index) => {
    setShowAll((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  useEffect(() => {
    setShowAll(false);
    fetchPerformanceDetails();
  }, [selectedFilter]);

  const fetchPerformanceDetails = async () => {
    let company_id = companyInfo.id;
    let filter =
      selectedFilter === "Monthly"
        ? "month"
        : selectedFilter === "Quarterly"
          ? "quarter"
          : selectedFilter === "Yearly"
            ? "year"
            : "month";

    let apiUrl = `${GetPerformance}/${company_id}/${filter}`;
    try {
      const res = await fetchApi(apiUrl, "GET");

      if (res.status === "success") {
        if (selectedFilter === "Yearly") {
          setData(res.data);
        } else {
          const formattedData = Object.entries(res.data)
            .filter(([, users]) => users?.length > 0)
            .map(([period, users]) => ({
              title: selectedFilter === "Quarterly" ? period.replace(/\|/g, " | ") : period,
              headers: ["Employees", "Total"],
              data: users.map((user) => ({
                name: user.user_name,
                department: user.department || "N/A",
                location: user.location || "N/A",
                total_posts: user.recognition_count,
                image: user.profile_image,
              })),
            }));

          setData(formattedData);

          if (formattedData.length === 0) {
            if (selectedFilter === "Monthly") {
              const months = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
              ];

              let formattedData = months.map((month) => ({
                title: month,
                headers: ["Employees", "Total"],
                data: [],
              }));

              setData(formattedData);
            } else if (selectedFilter === "Quarterly") {
              const months = [
                "January-March | Q1", "April-June | Q2", "July-September | Q3", "October-December | Q4"
              ];

              let formattedData = months.map((month) => ({
                title: month,
                headers: ["Employees", "Total"],
                data: [],
              }));

              setData(formattedData);
            }
          }
        }
      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  const NoDataFoundCard = () => (
    <YearlyCard style={{ justifyContent: "center", textAlign: "center", padding: "20px" }}>
      <div className="no-data">No Data Found</div>
    </YearlyCard>
  );

  return (
    <MainContainer margin>
       
      <PerformanceMain isGap={selectedFilter === "Yearly" ? "32px" : selectedFilter === "Quarterly" ? "20px" : "24px"}>
        {selectedFilter === "Yearly" ? (
          data?.length > 0 ? (
            data?.map((member, index) =>
              <div className='yearly' style={{ display: "block" }} key={index}>
                <YearlyCard>
                  {member?.profile_image !== "profile-Image/default.png" ? (
                    <div className='profile'>
                      <img src={ImageUrl + "/" + member.profile_image} alt={'no-image'} />
                    </div>
                  ) : (
                    <div className='profile'>
                      <NameInitials isSize="24px" isWidth="80px" isHeight="80px" id="name-initials">
                        {getInitials(member?.user_name)}
                      </NameInitials>
                    </div>
                  )}
                  <div className='name'>{member?.user_name || "\u00A0"}</div>
                  <div className='count'>{member?.recognition_count || "\u00A0"}</div>
                  <div className='department'>{member?.department || "-"}</div>
                  <div className='location'>{member?.location || "-"}</div>
                </YearlyCard>
              </div>
            )
          ) : (
            <NoDataFoundCard />
          )
        ) : (
          data.map((tableData, index) => (
            <div id={"per"+index} className={selectedFilter === "Quarterly" ? 'quarterly' : 'month'} style={{ display: "block" }} key={index}>
              <CommonTable
                key={index}
                title={tableData.title}
                headers={["Employees", "Total"]}
                data={tableData.data}
                showAll={showAll[index] || false}
                handleShowMore={() => handleShowMore(index)}
                imageBaseUrl={true}
              />
            </div>
          ))
        )}
      </PerformanceMain>
    </MainContainer>
  );
};

Performance.propTypes = {
  getColor: PropTypes.func.isRequired,
  selectedFilter: PropTypes.string,
  companyInfo: PropTypes.object,
};

export default Performance;


